module.exports = __webpack_public_path__ + "img/title-bar.3ef8aef1.jpg";